import { getBoundaries } from '../../../helpers/state-selector'
import StateHelper from '../../../helpers/state-abbreviation'
import moverHelper from '../../../helpers/mover-helper'
import mapHelper from '../../../helpers/map-helper'

import * as _ from 'lodash'

export default {
  name: 'get-state',
  data () {
    return {
      polygons: {},
      show_tag_box : false,
      tag_line : 'Begin by selecting a state you pickup moves in.',
      exclusion : false,
      infoboxes: {},
      tootip_display: false,
      tagline_2: false,
      loading : false,
      processing: false,
      showStateHelp: false,
      showUnselectStateHelp: false,
      showStateHelp2: false
    }
  },
  created () {
  },
  mounted () {

    // this.showInitialHelperMsg();
    this.fetchFilterSetsAndDetails();
  },
  destroyed () {
    this.$store.dispatch('removePolygons');
    this.$store.dispatch("removeSelectedAreas")
  },
  methods: {
    showInitialHelperMsg: function() {
      let showText = localStorage.getItem('showGetStateHelpText');
      if(!showText){
        this.showStateHelp = true
        localStorage.setItem('showGetStateHelpText', true)
        setTimeout( () => {
          this.showStateHelp = false;
        }, 7000);
      }
    },
    showSecondHelperMsg: function() {
      let showText = localStorage.getItem('showGetStateHelpText2');
      if(!showText){
        this.showStateHelp2 = true
        localStorage.setItem('showGetStateHelpText2', true)
        setTimeout( () => {
          this.showStateHelp2 = false;
        }, 7000);
      }
    },
    showUnselectHelperMsg() {
      let showUnselectText = localStorage.getItem('showUnselectStateHelpText');
      if(!showUnselectText){
        this.showUnselectStateHelp = true
        localStorage.setItem('showUnselectStateHelpText', true)
        setTimeout(() =>{
          this.showUnselectStateHelp = false
        }, 7000)
      }
    },
    fetchFilterSetsAndDetails() {
      if (this.$store.getters.selectedAreas.length < 1) {
        this.loading = true;
        this.fetchAreas().then(val => {
          if(this.$store.getters.selectedAreas.length){
            moverHelper.getFilterSetDetails().then(val => {
              this.loading = false;
            }).catch(err => {
              this.loading = false;
              alert("Something went Wrong")
            });
          }
          else{
            this.loading = false;
          }
        })
      } else {
        this.checkMap();
      }
    },
    fetchAreas() {
      return new Promise((resolve,reject) => {

        let api_url = process.env.API_URL + '/user/'+this.$store.getters.clientId;
        let params = {
          'token': this.$store.getters.accessToken,
          'w': 'pickups'
        };

        this.$http.get(api_url, {params: params}).then(response => {
          response = response.data || response;

          if (response) {
            if (response.completed_process) {
              this.$router.push('/thankyou');
              return;
            }

            let filter_sets = response.filter_sets || [];
            if (!response.completed_process) {
              filter_sets = [];
            }

            moverHelper.setUserData(response);
            moverHelper.setSelectedAreas(filter_sets);
          }
          this.checkMap()
                    
          resolve(true)
        }).catch(error => {
          this.loading = false;
          if (error.status && error.status == 401 ) {
            localStorage.setItem('access_token', '');
            localStorage.setItem('client_id', '');
            localStorage.setItem('user', '');
            
            this.$store.commit('setAccessToken', null);
            this.$store.commit('setClientId', null);
            this.$store.commit('setUser', null);
            this.$router.push('/pickup/client-login');
          }
          console.log(error);
        })
      })
    },
    closeHelperMsg(id) {
      document.getElementById(id).style.display = 'none';
    },
    checkMap() {
      mapHelper._isGoogleLoaded({infobox:true}).then(val =>{
        mapHelper.refreshMap().then(val => {
          this.makePolygons()
          setTimeout( ()=> {
            this.showInitialHelperMsg()
          }, 1000);
        })
      })
    },
    initSelectedStates(){
      mapHelper.initSelectedStates()
      this.exclusion = false;

      let selected_areas = this.$store.getters.selectedAreas;
      if (selected_areas.length) {
        
        if(this.showUnselectStateHelp){
          setTimeout( ()=> {
            this.showSecondHelperMsg()
          }, 7000);
        }else{
          this.showSecondHelperMsg()
        }

        this.exclusion = true;
      }
    },
    polygonHoverListeners(stateData){
      google.maps.event.addListener(this.$store.getters.polygons[stateData], 'mouseover', () => {
        if (this.$store.getters.polygons[stateData]) {
          this.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0.4, fillOpacity: 0.4 })
        }
      })
      google.maps.event.addListener(this.$store.getters.polygons[stateData], 'mouseout', () => {
        if (stateData !== this.$store.getters.selectedState && this.$store.getters.polygons[stateData]) {
          this.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0, fillOpacity: 0 })
        }
      })
    },
    polygonClickListner(stateData){
      google.maps.event.addListener(this.$store.getters.polygons[stateData],'click',() => {
        if(this.tootip_display){
          this.hideTooltip(this.$store.getters.selectedState)
          this.deselectPolygon(this.$store.getters.selectedState)
          if(stateData == this.$store.getters.selectedState ){
            this.$store.commit('setSelectedState', null)
            return; 
          }
        }
        this.$store.commit('setSelectedState', stateData)
        this.showTooltip(stateData)
        this.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0.4, fillOpacity: 0.4 })
      })
    },
    makePolygons () {
      this.$store.getters.map.setZoom(5)
      let boundaries = getBoundaries()
      this.$store.commit('setStates', Object.keys(boundaries))
      
      _.forEach(this.$store.getters.states, stateData => {

        mapHelper.makeStatePolygon(stateData, boundaries, [])
        this.polygonHoverListeners(stateData)
        this.polygonClickListner(stateData)
        this.$store.getters.polygons[stateData].setMap(this.$store.getters.map)
      
      })
      this.initSelectedStates()
      return 
    },
    selectPolygon (polygon) {
      this.$store.dispatch('removePolygons')
      let bounds = new google.maps.LatLngBounds()
      let boundaries = getBoundaries()
      for (let i = 0; i < polygon.getPath().length; i++) {
        let point = new google.maps.LatLng(boundaries[ this.$store.getters.selectedState ][i].lat(), boundaries[ this.$store.getters.selectedState ][i].lng())
        bounds.extend(point)
      }
      polygon.setOptions({ strokeOpacity: 1, fillOpacity: 0.3 })

      this.hideTooltip(this.$store.getters.selectedState)
      this.$router.push('/pickup/get-code/'+ this.$store.getters.selectedState)
    },
    deselectPolygon(stateData){
      this.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0, fillOpacity: 0 })
    },
    startExclusionProcess() {

      let selected_areas = this.$store.getters.selectedAreas;
      _.forEach(selected_areas, (area) => {
        delete area.inner_circle;
        delete area.inner_inner_circle;
        delete area.outer_circle;
        delete area.polygon;
      })

      if (this.tootip_display) {
        this.hideTooltip(this.$store.getters.selectedState);
      }
      this.$router.push('/pickup/get-state-exclusion');
    },
    showTooltip(state){
      let selected_area = moverHelper.getSelectedArea(state);
      let template = "";
      if(!selected_area || (selected_area && selected_area.area_codes.length == 0)) {
        template = "<div class='arrow_box infobox' ><h3 class='l-font ls-1 text-center infobox_header w-100 m-0'>Pickup: "+state+"</h3><div class='m-auto w-100 button_div'><button area='"+state+"' id='selectstate' class='sm-font ls-1 text-center'>Entire State</button><button class='sm-font ls-1 text-center b2' area='"+state+"' id='selectareacodes' >Specific Area Codes</button></div></div>";
      }
      else if(selected_area && selected_area.area_codes.length && selected_area.area_codes.length < selected_area.total_area_codes) {
        template = "<div class='arrow_box infobox' ><h3 class='l-font ls-1 text-center infobox_header w-100 m-0'>Pickup: "+state+"</h3><div class='m-auto w-100 button_div'><button area='"+state+"' id='selectstate' class='sm-font ls-1 text-center'>Entire State</button><button area='"+state+"' id='deselectstate' class='sm-font ls-1 text-center b2'>Unselect Entire State</button><button class='sm-font ls-1 text-center b2' area='"+state+"' id='selectareacodes' >Specific Area Codes</button></div></div>";
      }
      else if(selected_area && selected_area.area_codes.length == selected_area.total_area_codes) {
        template = "<div class='arrow_box infobox' ><h3 class='l-font ls-1 text-center infobox_header w-100 m-0'>Pickup: "+state+"</h3><div class='m-auto w-100 button_div'><button area='"+state+"' id='deselectstate' class='sm-font ls-1 text-center'>Unselect Entire State</button><button class='sm-font ls-1 text-center b2' area='"+state+"' id='selectareacodes' >Specific Area Codes</button></div></div>";
      }

      this.infoboxes[state] = new InfoBox({
        content: template,
        disableAutoPan: false,
        maxWidth: 150,
        alignBottom: true,
        pixelOffset: new google.maps.Size(-50, 0),
        zIndex: null,
        boxStyle: {
          opacity: 1,
          zIndex: 999,
          width: "260px",
          // height: (!selected_area || !selected_area.area_codes.length) ? "200px" : "230px",
          // overflow: "hidden"
        },
        closeBoxURL: "",
        infoBoxClearance: new google.maps.Size(1, 1),
        enableEventPropagation: false
      });
      let latlng = new google.maps.LatLng({lat: this.$store.getters.polygons[state].my_getBounds().getCenter().lat(), lng: this.$store.getters.polygons[state].my_getBounds().getCenter().lng()})
      this.infoboxes[state].setPosition(latlng)
      this.infoboxes[state].open(this.$store.getters.map)
      this.tootip_display = true;
      let context = this;

      context.infoboxes[state].addListener("domready", function(state) {
        document.getElementById("selectareacodes").addEventListener("click", function(e,state) {
          let area = e.target.getAttribute('area');
          context.selectPolygon(context.$store.getters.polygons[area])
        });
        if (!selected_area || (selected_area && (!selected_area.total_area_codes || selected_area.area_codes.length < selected_area.total_area_codes))) {
          document.getElementById("selectstate").addEventListener("click", function(e) {
            let area = e.target.getAttribute('area');
            context.selectEntireState(area)
          });
        }
        if (selected_area && selected_area.area_codes.length) {
          document.getElementById("deselectstate").addEventListener("click", function(e) {
            let area = e.target.getAttribute('area');
            context.unselectEntireState(area)
          });
        }
      });
    },
    hideTooltip(state){
      this.infoboxes[state].setMap(null)
      this.infoboxes[state]= null;
      this.tootip_display = false;
    },
    unselectEntireState(state) {
      this.hideTooltip(state)
      let selected_area = moverHelper.getSelectedArea(state);
      if (selected_area) {
        console.log('state is ', state, selected_area)
        selected_area.area_codes = []
        selected_area.status = "Not Active"

        this.$store.commit('updateSelectedArea', selected_area);
      }
      this.$store.dispatch('removeSelectedAreas');
      this.deselectPolygon(state)
      this.$store.commit('setSelectedState', null)
      this.initSelectedStates();
      
    },
    selectEntireState(state){
      console.log('select entire state',state);
      this.loading = true;
      //fetch area codes, add them to store
      this.hideTooltip(state)
      this.deselectPolygon(state)
      this.$http.get('https://valet.irelo.com/api/service/areacodes/' + state).then(response => {
        this.$store.dispatch("removeSelectedAreas")
        let area_codes = response.data || response;

        let is_new = false;
        let selected_area = moverHelper.getSelectedArea(state);
        if (!selected_area) {
          is_new = true;
          selected_area = {
            abbreviation: StateHelper.getAbbreviationByState(state),
            state: state,
            area_codes: []
          }
        }
        selected_area.area_codes = []
        selected_area.status = "Active"
        _.forEach(area_codes, (next_item)=>{
          selected_area.area_codes.push({
            zip_code: _.join(next_item.zipcode_list, ","),
            area_code: next_item.area_code
          })
          // this.$store.dispatch('addAreaCode', {"area_code": next_item, "state": this.$store.getters.selectedState})
        })
        selected_area.total_area_codes = response.data.length;

        if (is_new) {
          this.$store.dispatch('addSelectedArea', selected_area);
        } else {
          this.$store.commit('updateSelectedArea', selected_area);
        }

        this.$store.commit('setSelectedState', null)
        this.loading = false;
        this.showUnselectHelperMsg()
        this.initSelectedStates()
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Pickup/GetState/get-state.script.js